module.exports = __webpack_public_path__ + "img/576.6ff057ad.jpg";